import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Casinos from "./pages/Casinos";
import CasinoDetail from "./pages/CasinoDetail";
import ExitIntentPopup from './components/ExitIntentPopup';
import LuckySpinPopup from './components/LuckySpinPopup';
import BlogGenerator from './pages/BlogGenerator';
import PromoCodes from './pages/PromoCodes';
import Bonuses from "./pages/Bonuses";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Complaint from "./pages/Complaint";
import Partnership from "./pages/Partnership";
import Contact from "./pages/Contact";
import About from "./pages/About";
import CasinoSlot from "./pages/CasinoSlot";
import CasinoSlotCasea from "./pages/CasinoSlotCasea";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import WinJackpot from "./pages/WinJackpot";
import WinJackpotJapan from "./pages/WinJackpotJapan";
import "@/App.css";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
      <ScrollToTop />
        <Toaster 
          position="top-right" 
          richColors 
          toastOptions={{
            style: {
              background: 'hsl(270 40% 12%)',
              border: '1px solid hsl(270 30% 25%)',
              color: 'white',
            },
          }}
        />
        <Routes>
          <Route path="/win-Jackpot" element={<WinJackpot />} />
          <Route path="/win-Jackpot-Japan" element={<WinJackpotJapan />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/casinos" element={<Casinos />} />
            <Route path="/casinos/:slug" element={<CasinoDetail />} />
            <Route path="/admin/blog-generator" element={<BlogGenerator />} />
          <Route path="/promo-codes" element={<PromoCodes />} />
          <Route path="/bonuses" element={<Bonuses />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/complaint" element={<Complaint />} />
            <Route path="/partnership" element={<Partnership />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
          <Route path="/casino-slot" element={<CasinoSlot />} />
          <Route path="/casino-slot-casea" element={<CasinoSlotCasea />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Route>
        </Routes>
        <LuckySpinPopup />
    <ExitIntentPopup />
    </BrowserRouter>
    </div>
  );
}

export default App;
